import React from 'react';
import { useLocation } from 'react-router-dom';
import { isEmpty } from '../../../helpers/common';
import { CUSTOMER_MEMBER_ROLE } from '../../../global/constants';
import { MenuItem } from '../menuItem';
import { useMobileDevice } from '../../../global/useMobile';
import { ROUTES } from '../../../routes/urls';
import { MainMenu } from './styles';
import { observer } from 'mobx-react-lite';
import { rootStore } from '../../../mobx/rootStore';
import NotificationBadge from './notificationBadge';
import InvoiceBadge from './invoiceBadge';

const NavbarMenuItems: React.FC = () => {
  const { workspaceStore, projectStore } = rootStore;
  const { currentWorkspace: workspaceDetail } = workspaceStore || {};
  const { apps, isAdmin, customerRole } = workspaceDetail || {};
  const { favoriteProjects } = projectStore || {};
  const location = useLocation();
  const mobile = useMobileDevice();

  const menuItemsBeforeInvoices = [
    {
      path: '/my-tasks',
      icon: 'navbar-MyTask-icon',
      label: 'My Tasks',
      visible: true
    },
    {
      path: '/messages',
      icon: 'message-icon',
      label: 'Messages',
      visible: isEmpty(apps?.messages) || apps?.messages === true
    },
    {
      path: '/views',
      icon: 'navbar-views-icon',
      label: 'Views',
      className: 'fill-color',
      visible: apps?.views === true
    }
  ];

  const menuItemsAfterInvoices = [
    {
      path: '/projects',
      icon: 'project-icon',
      label: 'Projects',
      visible: !(favoriteProjects?.length > 0)
    },
    {
      path: '/customer',
      icon: 'customer-icon',
      label: 'Customers',
      visible: isAdmin && (isEmpty(apps?.customer) || apps?.customer === true)
    },
    {
      path: '/timeTracking',
      icon: 'navbar-TimeTracking-icon',
      label: 'Time Tracking',
      visible:
        (isEmpty(apps?.timeTracking) || apps?.timeTracking === true) &&
        customerRole !== CUSTOMER_MEMBER_ROLE.PROJECT_ONLY &&
        customerRole !== CUSTOMER_MEMBER_ROLE.FULL_ACCESS
    }
  ];

  const renderMenuItems = (
    items: { path: string; icon: string; label: string; visible?: boolean; className?: string }[]
  ) =>
    items
      .filter((item) => item.visible)
      .map((item) => (
        <MenuItem
          key={item.path}
          path={item.path}
          isActive={location?.pathname?.startsWith(item.path)}
          iconName={item.icon}
          label={item.label}
          className={item.className}
        />
      ));

  return (
    <MainMenu>
      <NotificationBadge isActive={location?.pathname === '/'} />
      {renderMenuItems(menuItemsBeforeInvoices)}
      {(isAdmin || customerRole === CUSTOMER_MEMBER_ROLE.FULL_ACCESS) &&
        (isEmpty(apps?.invoiceAndPayment) || apps?.invoiceAndPayment === true) && (
          <InvoiceBadge isActive={location?.pathname?.startsWith('/invoices')} />
        )}
      {renderMenuItems(menuItemsAfterInvoices)}
      {isAdmin && (
        <MenuItem
          path={mobile ? ROUTES.REPORT : ROUTES.REPORT_PAYMENTS}
          isActive={location?.pathname?.startsWith('/report')}
          iconName='navbar-Report-icon'
          label='Reports'
        />
      )}
    </MainMenu>
  );
};

export default observer(NavbarMenuItems);
